export default __webpack_public_path__ + "static/media/sidemenuleft.8cc50831.png";